// @ts-nocheck
// PurchaseOrders types for Redux actions

const PURCHASE_ORDERS_TABLE_STATE_SET = 'PURCHASE_ORDERS/TABLE_STATE_SET';
const PURCHASE_ORDERS_TABLE_STATE_RESET = 'PURCHASE_ORDERS/TABLE_STATE_RESET';

export default {
  PURCHASE_ORDERS_TABLE_STATE_SET,
  PURCHASE_ORDERS_TABLE_STATE_RESET,
};
